module.exports = __webpack_public_path__ + "static/media/Icn-key.b7eac931.svg";